import {DifficultIcon, FireIcon, NewIcon} from 'icons';
import React from 'react';
import {difficultyLevels} from 'types/levels';
import {QuestionListExtraFilter} from 'types/questions';
import {QuickFilter} from './quick_filter';
import styles from './quick_filters.module.css';

export const QuickFilters = ({config, onConfigChange}: Props) => {
  return (
    <div className={styles.quickFilters}>
      <QuickFilter
        name='Popular questions'
        icon={<FireIcon />}
        configKey='extraFilters'
        value={QuestionListExtraFilter.Popular}
        config={config}
        onConfigChange={onConfigChange}
      />
      <QuickFilter
        name='Difficult questions'
        icon={<DifficultIcon />}
        configKey='levels'
        value={difficultyLevels.Hard}
        config={config}
        onConfigChange={onConfigChange}
      />
      <QuickFilter
        name='New questions'
        icon={<NewIcon />}
        configKey='extraFilters'
        value={QuestionListExtraFilter.Recent}
        config={config}
        onConfigChange={onConfigChange}
      />
    </div>
  );
};

type Props = {
  config: QuestionListConfig;
  onConfigChange: (config: QuestionListConfig) => void;
};
